var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85034 14.4189H7.70192V13.1359H8.52813C9.38536 13.1359 9.95778 12.5832 9.95778 11.7457V11.7401C9.95778 10.9026 9.38536 10.3499 8.52813 10.3499H6.85034V14.4189ZM8.31947 11.0239C8.8073 11.0239 9.09492 11.2804 9.09492 11.7429V11.7485C9.09492 12.211 8.8073 12.4704 8.31947 12.4704H7.70192V11.0239H8.31947Z",
    fill: "#4C5664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5588 14.4189H12.1605C13.3787 14.4189 14.0695 13.6745 14.0695 12.3604V12.3548C14.0695 11.0803 13.3702 10.3499 12.1605 10.3499H10.5588V14.4189ZM11.4104 13.7168V11.0521H12.0252C12.764 11.0521 13.201 11.5314 13.201 12.3689V12.3745C13.201 13.243 12.778 13.7168 12.0252 13.7168H11.4104Z",
    fill: "#4C5664"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6958 14.4189H15.5474V12.8172H17.2026V12.1433H15.5474V11.0521H17.3605V10.3499H14.6958V14.4189Z",
    fill: "#4C5664"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 23H20.6V1H6.96537L3 4.98748V23ZM18.4 20.8H5.2V6.22497L8.08756 3.2H18.4V20.8Z",
    fill: "#4C5664"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9a94cf630fee10d87605f8b185b2e979.svg";
export { ForwardRef as ReactComponent };